import React from "react";
import WebsiteLogo from "../images/Logo.png";
import { FaInstagramSquare, FaWhatsappSquare } from "react-icons/fa";

const Footer = () => {
  return (
    <div>
      <section className="footer bg-accent">
        <div className="container split flow-content">
          <div className="footer__upper split flow-content">
            <div className="footer__desc">
              <div className="footer__logo">
                <img src={WebsiteLogo} alt="" />
              </div>
              <p>Every celebration is a story worth styling beautifully.</p>
              <p>
                Connect with us: <strong>+91-93192 03057</strong> |{" "}
                <strong>team@pixiuevents.com</strong>
              </p>
              <div className="social-links">
                <ul>
                  <li>
                    <a
                      href="https://www.instagram.com/pixiuevents/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <FaInstagramSquare />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://wa.me/919319203057?text=Hi%20I%20want%20to%20connect%20with%20you"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaWhatsappSquare />
                    </a>
                  </li>
                  {/* <li>
                    <button>
                      <FaPinterestSquare />
                    </button>
                  </li> */}
                </ul>
              </div>
            </div>
            {/* <div className="footer__links flow-content split">
              <div className="footer__links__items">
                <h4>Home</h4>
                <ul>
                  <li>
                    <button>Home</button>
                  </li>
                  <li>
                    <button>Services</button>
                  </li>
                  <li>
                    <button>About</button>
                  </li>
                  <li>
                    <button>Contact</button>
                  </li>
                </ul>
              </div>
              <div className="footer__links__items">
                <h4>Link</h4>
                <ul>
                  <li>
                    <button>Home</button>
                  </li>
                  <li>
                    <button>Services</button>
                  </li>
                  <li>
                    <button>About</button>
                  </li>
                  <li>
                    <button>Contact</button>
                  </li>
                </ul>
              </div>
              <div className="footer__links__items">
                <h4>Contact</h4>
                <ul>
                  <li>
                    <button>Home</button>
                  </li>
                  <li>
                    <button>Services</button>
                  </li>
                  <li>
                    <button>About</button>
                  </li>
                  <li>
                    <button>Contact</button>
                  </li>
                </ul>
              </div>
            </div> */}
          </div>
          <div className="footer__lower split">
            {/* <div className="footer__lower__links">
              <button>Terms of Service</button>
              <button>Privacy Policy</button>
            </div> */}
            <div>
              <span className="copywrite">
                © 2025 Pixiu Events. Crafted with care.
              </span>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Footer;
